module.exports = __webpack_public_path__ + "static/img/home_5.0ea0924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_5.png
// module id = NDOq
// module chunks = 1